<template>
  <div class="sidebar-logo-container" :class="{ 'collapse': collapse }">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <img v-if="logo" :src="logo" class="sidebar-logo">
        <h1 v-else class="sidebar-title">{{ title }} </h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="logo" :src="logo" class="sidebar-logo">
        <h1 class="sidebar-title">{{ title }} </h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: 'Vue Admin Template',
      logo: 'https://wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png'
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: linear-gradient(135deg, #1a2332 0%, #0f1419 100%); // 渐变背景与侧边栏协调
  text-align: center;
  overflow: hidden;
  border-bottom: 1px solid rgba(100, 181, 246, 0.15); // 蓝色光晕分隔线
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2); // 底部阴影

  // 添加顶部微妙的光晕
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg,
        transparent 0%,
        rgba(100, 181, 246, 0.3) 50%,
        transparent 100%);
  }

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      transform: scale(1.02);

      .sidebar-title {
        color: #64b5f6; // 悬停时使用主题蓝色
      }
    }

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
      border-radius: 4px; // 圆角
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3)); // 图标阴影
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #e1e6ed;
      font-weight: 600;
      line-height: 50px;
      font-size: 16px; // 稍大一点
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
      vertical-align: middle;
      letter-spacing: 0.5px; // 字间距
      text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3); // 文字阴影
      transition: color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
